"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemCls = void 0;
var PublicKeyAccount_1 = require("../account/PublicKeyAccount");
// import * as base58 from "bs58";
var Transaction_1 = require("../transaction/Transaction");
var Bytes_1 = require("../Bytes");
var DataWriter_1 = require("../DataWriter");
var AppData_1 = require("./AppData");
var regexURL = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/i;
var ItemCls = /** @class */ (function () {
    function ItemCls(typeBytes, owner, name, icon, image, description, iconType, imageType) {
        var _this = this;
        this.initAppData = function () { return __awaiter(_this, void 0, void 0, function () {
            var sIcon, sImage, isIconURL, isImageURL, iconType, imageType, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.appData)
                            return [2 /*return*/, true];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, Bytes_1.Bytes.stringFromByteArray(this.icon)];
                    case 2:
                        sIcon = (_a.sent()).toLowerCase();
                        return [4 /*yield*/, Bytes_1.Bytes.stringFromByteArray(this.image)];
                    case 3:
                        sImage = (_a.sent()).toLowerCase();
                        isIconURL = regexURL.test(sIcon);
                        isImageURL = regexURL.test(sImage);
                        iconType = new Int8Array([0]);
                        if (isIconURL) {
                            if ((sIcon.indexOf(".jpg") >= 0) ||
                                (sIcon.indexOf(".jpeg") >= 0) ||
                                (sIcon.indexOf(".gif") >= 0) ||
                                (sIcon.indexOf(".png") >= 0)) {
                                iconType = new Int8Array([-128 | 0]);
                            }
                            else if ((sIcon.indexOf(".mp4") >= 0)) {
                                iconType = new Int8Array([-128 | 1]);
                            }
                        }
                        imageType = new Int8Array([0]);
                        if (isImageURL) {
                            if ((sImage.indexOf(".jpg") >= 0) ||
                                (sImage.indexOf(".jpeg") >= 0) ||
                                (sImage.indexOf(".gif") >= 0) ||
                                (sImage.indexOf(".png") >= 0)) {
                                imageType = new Int8Array([-128 | 0]);
                            }
                            else if ((sImage.indexOf(".mp4") >= 0)) {
                                imageType = new Int8Array([-128 | 1]);
                            }
                        }
                        if (isIconURL || isImageURL) {
                            this.appData = new AppData_1.AppData(iconType, imageType);
                            return [2 /*return*/, true];
                        }
                        // Если не ссылки, то смотрим iconType и imageType
                        if (this.iconType) {
                            iconType = new Int8Array([this.iconType]);
                        }
                        if (this.imageType) {
                            imageType = new Int8Array([this.imageType]);
                        }
                        if (this.iconType || this.imageType) {
                            this.appData = new AppData_1.AppData(iconType, imageType);
                            return [2 /*return*/, true];
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, false];
                }
            });
        }); };
        this.typeBytes = typeBytes;
        this.owner = owner;
        this.name = name.trim();
        this.icon = icon;
        this.image = image;
        this.description = description.trim();
        this.iconType = iconType !== null && iconType !== void 0 ? iconType : 0;
        this.imageType = imageType !== null && imageType !== void 0 ? imageType : 0;
        this.initAppData();
        // this.reference = Bytes.ensureCapacity(base58.decode(name), ItemCls.REFERENCE_LENGTH, 0) as Int8Array;
    }
    ItemCls.prototype.getDataLength = function (includeReference) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = ItemCls.BASE_LENGTH;
                        return [4 /*yield*/, Bytes_1.Bytes.stringToByteArray(this.name)];
                    case 1:
                        _b = _a +
                            (_c.sent()).length +
                            this.icon.length +
                            this.image.length +
                            (this.appData ? this.appData.getDataLength() : 0);
                        return [4 /*yield*/, Bytes_1.Bytes.stringToByteArray(this.description)];
                    case 2: return [2 /*return*/, (_b +
                            (_c.sent()).length +
                            (includeReference ? ItemCls.REFERENCE_LENGTH : 0))];
                }
            });
        });
    };
    ItemCls.prototype.toBytes = function (includeReference, forOwnerSign) {
        return __awaiter(this, void 0, void 0, function () {
            var data, useAll, bytesAppData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = new DataWriter_1.DataWriter();
                        useAll = !forOwnerSign;
                        //console.log("ItemCls", { includeReference, forOwnerSign, useAll });
                        if (useAll) {
                            //WRITE TYPE
                            this.typeToBytes(data);
                        }
                        if (useAll) {
                            // WRITE OWNER
                            this.ownerToBytes(data);
                        }
                        //WRITE NAME
                        return [4 /*yield*/, this.nameToBytes(data, useAll)];
                    case 1:
                        //WRITE NAME
                        _a.sent();
                        if (!useAll) return [3 /*break*/, 3];
                        //WRITE ICON SIZE - 2 bytes = 64kB max
                        //WRITE ICON
                        return [4 /*yield*/, this.iconToBytes(data)];
                    case 2:
                        //WRITE ICON SIZE - 2 bytes = 64kB max
                        //WRITE ICON
                        _a.sent();
                        _a.label = 3;
                    case 3: 
                    //console.log("ItemCls2", { data });
                    return [4 /*yield*/, this.imageToBytes(data, useAll)];
                    case 4:
                        //console.log("ItemCls2", { data });
                        _a.sent();
                        if (!this.appData) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.appData.toBytes()];
                    case 5:
                        bytesAppData = _a.sent();
                        data.set(bytesAppData);
                        _a.label = 6;
                    case 6: 
                    //console.log("ItemCls3", { data });
                    // WRITE DESCRIPTION
                    return [4 /*yield*/, this.descriptionToBytes(data, useAll)];
                    case 7:
                        //console.log("ItemCls3", { data });
                        // WRITE DESCRIPTION
                        _a.sent();
                        //console.log("ItemCls4", { data });
                        if (useAll && includeReference && this.reference) {
                            //WRITE REFERENCE
                            data.set(this.reference);
                        }
                        //console.log("ItemCls5", { data });
                        return [2 /*return*/, data.data];
                }
            });
        });
    };
    ItemCls.prototype.toBytesWithoutAppData = function (includeReference, forOwnerSign) {
        return __awaiter(this, void 0, void 0, function () {
            var data, useAll;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = new DataWriter_1.DataWriter();
                        useAll = !forOwnerSign;
                        //console.log("ItemCls", { includeReference, forOwnerSign, useAll });
                        if (useAll) {
                            //WRITE TYPE
                            this.typeToBytes(data);
                        }
                        if (useAll) {
                            // WRITE OWNER
                            this.ownerToBytes(data);
                        }
                        //WRITE NAME
                        return [4 /*yield*/, this.nameToBytes(data, useAll)];
                    case 1:
                        //WRITE NAME
                        _a.sent();
                        if (!useAll) return [3 /*break*/, 3];
                        //WRITE ICON SIZE - 2 bytes = 64kB max
                        //WRITE ICON
                        return [4 /*yield*/, this.iconToBytes(data)];
                    case 2:
                        //WRITE ICON SIZE - 2 bytes = 64kB max
                        //WRITE ICON
                        _a.sent();
                        _a.label = 3;
                    case 3: 
                    //console.log("ItemCls2", { data });
                    return [4 /*yield*/, this.imageToBytes(data, useAll)];
                    case 4:
                        //console.log("ItemCls2", { data });
                        _a.sent();
                        //console.log("ItemCls3", { data });
                        // WRITE DESCRIPTION
                        return [4 /*yield*/, this.descriptionToBytes(data, useAll)];
                    case 5:
                        //console.log("ItemCls3", { data });
                        // WRITE DESCRIPTION
                        _a.sent();
                        //console.log("ItemCls4", { data });
                        if (useAll && includeReference && this.reference) {
                            //WRITE REFERENCE
                            data.set(this.reference);
                        }
                        //console.log("ItemCls5", { data });
                        return [2 /*return*/, data.data];
                }
            });
        });
    };
    ItemCls.prototype.typeToBytes = function (dataWriter) {
        dataWriter.set(this.typeBytes);
    };
    ItemCls.prototype.ownerToBytes = function (dataWriter) {
        dataWriter.set(this.owner.publicKey);
    };
    ItemCls.prototype.nameToBytes = function (dataWriter, prependLength) {
        if (prependLength === void 0) { prependLength = false; }
        return __awaiter(this, void 0, void 0, function () {
            var name;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Bytes_1.Bytes.stringToByteArray(this.name)];
                    case 1:
                        name = _a.sent();
                        if (prependLength) {
                            dataWriter.setNumber(name.length);
                        }
                        dataWriter.set(name);
                        return [2 /*return*/];
                }
            });
        });
    };
    ItemCls.prototype.iconToBytes = function (dataWriter) {
        return __awaiter(this, void 0, void 0, function () {
            var length, iconsLength;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        length = this.icon.length;
                        return [4 /*yield*/, Bytes_1.Bytes.intToByteArray(length)];
                    case 1:
                        iconsLength = _a.sent();
                        dataWriter.set(new Int8Array([iconsLength[2], iconsLength[3]]));
                        dataWriter.set(this.icon);
                        return [2 /*return*/];
                }
            });
        });
    };
    ItemCls.prototype.imageToBytes = function (dataWriter, prependLength) {
        if (prependLength === void 0) { prependLength = false; }
        return __awaiter(this, void 0, void 0, function () {
            var length, bytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!prependLength) return [3 /*break*/, 2];
                        length = this.image.length;
                        if (this.appData) {
                            length = length | 1 << 31;
                        }
                        return [4 /*yield*/, Bytes_1.Bytes.intToByteArray(length)];
                    case 1:
                        bytes = _a.sent();
                        dataWriter.set(bytes);
                        _a.label = 2;
                    case 2:
                        dataWriter.set(this.image);
                        return [2 /*return*/];
                }
            });
        });
    };
    ItemCls.prototype.descriptionToBytes = function (dataWriter, prependLength) {
        if (prependLength === void 0) { prependLength = false; }
        return __awaiter(this, void 0, void 0, function () {
            var description, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, Bytes_1.Bytes.stringToByteArray(this.description)];
                    case 1:
                        description = _c.sent();
                        if (!prependLength) return [3 /*break*/, 3];
                        _b = (_a = dataWriter).set;
                        return [4 /*yield*/, Bytes_1.Bytes.intToByteArray(description.length)];
                    case 2:
                        _b.apply(_a, [_c.sent()]);
                        _c.label = 3;
                    case 3:
                        dataWriter.set(description);
                        return [2 /*return*/];
                }
            });
        });
    };
    ItemCls.MAX_ICON_LENGTH = 51200;
    ItemCls.MAX_IMAGE_LENGTH = 1100000;
    ItemCls.HAIR_COLOR_SIZE_LENGTH = 1;
    ItemCls.MAX_HAIR_COLOR_LENGTH = 256 ^ (ItemCls.HAIR_COLOR_SIZE_LENGTH - 1);
    ItemCls.EYE_COLOR_SIZE_LENGTH = 1;
    ItemCls.MAX_EYE_COLOR_LENGTH = 256 ^ (ItemCls.EYE_COLOR_SIZE_LENGTH - 1);
    ItemCls.SKIN_COLOR_SIZE_LENGTH = 1;
    ItemCls.MAX_SKIN_COLOR_LENGTH = 256 ^ (ItemCls.SKIN_COLOR_SIZE_LENGTH - 1);
    ItemCls.RACE_SIZE_LENGTH = 1;
    ItemCls.MAX_RACE_LENGTH = 256 ^ (ItemCls.RACE_SIZE_LENGTH - 1);
    ItemCls.REFERENCE_LENGTH = Transaction_1.Transaction.SIGNATURE_LENGTH;
    ItemCls.TIMESTAMP_LENGTH = Transaction_1.Transaction.TIMESTAMP_LENGTH;
    ItemCls.BIRTHDAY_LENGTH = ItemCls.TIMESTAMP_LENGTH;
    ItemCls.DEATHDAY_LENGTH = ItemCls.TIMESTAMP_LENGTH;
    ItemCls.LATITUDE_LENGTH = 4;
    ItemCls.TYPE_LENGTH = 2;
    ItemCls.OWNER_LENGTH = PublicKeyAccount_1.PublicKeyAccount.PUBLIC_KEY_LENGTH;
    ItemCls.NAME_SIZE_LENGTH = 1;
    ItemCls.MAX_NAME_LENGTH = Math.pow(256, ItemCls.NAME_SIZE_LENGTH) - 1;
    ItemCls.IMAGE_SIZE_LENGTH = 4;
    ItemCls.ICON_SIZE_LENGTH = 2;
    ItemCls.DESCRIPTION_SIZE_LENGTH = 4;
    ItemCls.BASE_LENGTH = ItemCls.TYPE_LENGTH +
        ItemCls.OWNER_LENGTH +
        ItemCls.NAME_SIZE_LENGTH +
        ItemCls.ICON_SIZE_LENGTH +
        ItemCls.IMAGE_SIZE_LENGTH +
        ItemCls.DESCRIPTION_SIZE_LENGTH;
    return ItemCls;
}());
exports.ItemCls = ItemCls;
